var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.12508 5.87502V0.666687C7.12508 0.500927 7.05923 0.341955 6.94202 0.224745C6.82481 0.107535 6.66584 0.041687 6.50008 0.041687C6.33432 0.041687 6.17535 0.107535 6.05814 0.224745C5.94093 0.341955 5.87508 0.500927 5.87508 0.666687V5.87502H0.666748C0.500988 5.87502 0.342016 5.94087 0.224806 6.05808C0.107596 6.17529 0.041748 6.33426 0.041748 6.50002C0.041748 6.66578 0.107596 6.82475 0.224806 6.94196C0.342016 7.05917 0.500988 7.12502 0.666748 7.12502H5.87508V12.3334C5.87724 12.4984 5.94378 12.6562 6.06053 12.7729C6.17727 12.8897 6.33499 12.9562 6.50008 12.9584C6.66584 12.9584 6.82481 12.8925 6.94202 12.7753C7.05923 12.6581 7.12508 12.4991 7.12508 12.3334V7.12502H12.3334C12.4992 7.12502 12.6581 7.05917 12.7754 6.94196C12.8926 6.82475 12.9584 6.66578 12.9584 6.50002C12.9563 6.33493 12.8897 6.17721 12.773 6.06047C12.6562 5.94372 12.4985 5.87718 12.3334 5.87502H7.12508Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a662cd0593cfa1b45c3bb5355961b163.svg";
export { ForwardRef as ReactComponent };